import { createRouter, createWebHistory, createWebHashHistory,RouteLocationNormalized } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import store from '@/store';
import axios from 'axios';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //history: createWebHashHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  const code = to.query.code as string;
  if (token) {
    const isValid = await store.dispatch('checkToken', token);
    if (isValid) {
      next();
    } else {
      redirectToWeChatAuth();
    }
  } else if (code) {
    try {
      await store.dispatch('exchangeToken', { code });
      next();
    } catch (error) {
      console.error('Token exchange failed:', error);
      redirectToWeChatAuth();
    }
  } else {
    redirectToWeChatAuth();
  }
});

async function redirectToWeChatAuth() {
  try {
    const response = await axios.get('/zwai/api/wechat/oauthUrl', {
      params: { oauth_callback: window.location.origin },
      headers: {
        Authorization: "Pass"
      }
    });
    const authUrl = response.data;
    window.location.href = authUrl;
  } catch (error) {
    console.error('Failed to get WeChat auth URL:', error);
  }
}

export default router;
